export default "__VITE_ASSET__7b3cd934__"